export default __webpack_public_path__ + "static/media/008-toy boat.cc6a0e16.svg";